<template>
  <el-dialog 
    v-bind="$attrs"
    v-on="$listeners"
    :inheritAttrs="false"
    :title="title" 
    custom-class="dialog" 
    width="520px"
    v-drag
    :append-to-body="true">
    <div class="content">
      <div class="form-item" v-for="(item, index) in remarkList">
        <div class="desc">{{item.description}}</div>
        <div class="content" v-if="item.type==='text'">
          <el-input type="textarea" :rows="4" v-model="item.value" maxlength="1000" show-word-limit></el-input>
        </div>
        <div class="content" v-else-if="item.type==='number'">
          <el-rate v-model="item.value" :max="10"></el-rate>
        </div>
        <div class="content" v-else-if="item.type==='radio'">
          <el-radio-group v-model="item.value">
            <el-radio class="single-row-form-item" :label="option" v-for="(option, i) in item.options" :key="'option-'+i"></el-radio>
          </el-radio-group>
        </div>
        <div class="content" v-else-if="item.type==='checkbox'">
          <el-checkbox-group v-model="item.value">
            <el-checkbox class="single-row-form-item" :label="option" v-for="(option,i) in item.options" :key="'option-'+i"></el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div class="form-item">
        <div class="title">结果</div>
        <div class="info">请给出候选人的面试结果</div>
        <el-radio-group v-model="remarkObj.auditStatus">
          <el-radio :label="1">通过</el-radio>
          <el-radio :label="2">拒绝</el-radio>
          <el-radio :label="3">待定</el-radio>
        </el-radio-group>
      </div>
      <div class="form-item">
        <div class="title">综合评价</div>
        <div class="info">请详细说明候选人的优势、不足及任何值得注意的方面</div>
        <el-input type="textarea" :rows="4" v-model="remarkObj.remark" maxlength="1000" show-word-limit></el-input>
      </div>
    </div>
    <div slot="footer" class="footer" style="margin-top:1px;">
        <el-button class="cancel" size="small" @click="$emit('close')">取消</el-button>
        <el-button type="primary" size="small" :loading="loading" @click="editRemark()">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import toolkit from "@/util/toolkit"
import config from "@/util/config"
import { getCookie } from "@/util/cookie"
import { setCookie } from '../util/cookie'
export default {
  props: {
    title:{
      type: String,
      default: "面试反馈"
    },
    remarkInfo: {
      type: Object,
      default(){
        return {
          interviewId: "",
          remark: "",
          auditStatus: 0,
          remarkJson: ""
        }
      }
    },
    isNew: {
      type: Boolean,
      default: false
    },
    connectCode: {
      type: String,
      default: ""
    }
  },
  data(){
    return{
      loading: false,
      value: "",
      remarkObj: {},
      remarkList: [],
      initialRemarkList: [],
      companyId: "",
    }
  },
  watch: {
    remarkInfo(value){
      this.remarkObj = value
      if(value.remarkJson){
        this.remarkList = JSON.parse(value.remarkJson)
      }else{
        this.remarkList = JSON.parse(JSON.stringify(this.initialRemarkList))
      }
    },
    connectCode(val) {
      if(val != "") {
        this.getRemarkList()
      }
    }
  },
  mounted(){
    if (!this.isNew) {
      this.getRemarkList()
    }
    let companyTimeout = setTimeout(() => {
      this.companyId = getCookie('currentInterviewCompanyId')
    }, 2000)
  },
  methods: {
    getRemarkList(){
      toolkit.post("/interview/info/feedbackTemplateList", {
        connectCode: this.connectCode
      }).then(res => {
        if(res.code == 0){
          let list = res.data.list
          if(list && list.length){
            this.initialRemarkList = JSON.parse(list[0].questions)
            this.initialRemarkList.forEach(e => { // 格式化数据格式
              if(e.type == 'number'){
                e.value = Number(e.value)
              }
            })
            this.remarkList = JSON.parse(JSON.stringify(this.initialRemarkList))
            this.$forceUpdate()
          }
        }
      })
    },
    editRemark(){
      this.loading = true
      let params = {
        connectCode: this.remarkObj.candidateConnectCode,
        remark: this.remarkObj.remark,
        auditStatus: this.remarkObj.auditStatus,
        remarkJson: JSON.stringify(this.remarkList)
      }
      if(this.remarkInfo.multiRemark){
        params.interviewId = this.remarkInfo.interviewId
      }
      if ((this.companyId == 83332 || this.companyId == 85971) && (!params.auditStatus || !params.remark || !params.remarkJson)) {
        this.$message.info('请完整填写面试反馈')
        this.loading = false;
      } else {
        toolkit.post('/interview/video/updateMember', params).then(res => {
          if(res.code == 0){
            this.$message.success('修改成功')
            this.$emit("close")
            this.$emit("success", params)
          }else{
            this.$message.error(res.message)
          }
        }).finally(() => {
          this.loading = false
          if (this.remarkObj.remark && this.remarkObj.auditStatus && this.remarkList) {
            if (this.companyId == 83332 || this.companyId == 85971) {
              console.log("candidateConnectCode: ", this.connectCode);
              setCookie('remarkConnect-' + this.connectCode, true, config.userTokenExpire);
            }
          }
        })
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.content{
  .form-item{
    margin-top: 25px;
    &:first-child{
      margin-top: 0;
    }
    .title{
      font-weight: 500;
    }
    .info{
      font-size: 13px;
      color: $SubColor;
      margin: 6px 0 10px;
    }
    .desc{
      margin: 10px 0;
    }
    .single-row-form-item{
      margin: 10px 0;
    }
  }
}
.footer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -35px;
    margin-bottom: 10px;
    .el-button {
        width: 150px;
        margin: 0 10px;
        font-size: 13px;
    }
    .cancel{
        color: #C5C7C9;
        background: #ECECED;
        border-color: transparent;
        &:hover{
            color: #3E444C;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/AddRemark.vue